import moment from 'moment';

export const secondsToHms = (d: number) => {
  d = Number(d);
  const hour = Math.floor(d / 3600);
  const minute = Math.floor((d % 3600) / 60);
  const second = Math.floor((d % 3600) % 60);

  const hDisplay = hour > 0 ? `${hour} h ` : '';
  const mDisplay = minute > 0 ? `${minute} m ` : '';
  const sDisplay = second > 0 ? `${second} s` : '';

  return hDisplay || mDisplay || sDisplay
    ? hDisplay + mDisplay + sDisplay
    : '0 s';
};

export const formatIsoDateTimeStringToDisplayDate = (
  date: string | null | undefined
) => {
  // Check if the date is null, undefined, or an invalid date
  if (!date || !moment(date).isValid()) {
    return ''; // Return an empty string for invalid dates
  }

  return moment(date).format('DD/MM/YYYY HH:mm');
};

export const formatIsoDateTimeStringToLongMonthDisplayDate = (date: string) => {
  return moment(date).format('DD MMMM YYYY');
};

export const formatIsoDateStringToDisplayDate = (date: string) => {
  return moment(date).format('DD/MM/YYYY');
};

export const formatIsoDateStringToDisplayTimeOnly = (date: string) => {
  return moment(date).format('HH:mm');
};
